
(function ($, d, ns) {
    ns.initGalleryZoom = function () {
        $('.js-gallery-zoom').on('click', function (e) {
            e.preventDefault();
            var zoomedURL = $(this).attr('href');
            $('.js-gallery-zoom-placeholder').attr('src', zoomedURL);
            $('#js-gallery-zoom').foundation('reveal', 'open');
        });


    }

    $(d).ready(function () {
        ns.initGalleryZoom();
    });

})(jQuery, document, Crafted.Utilities);